var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"class_error"},[_c('router-link',{attrs:{"to":"/home"}},[_vm._v("返回首页")]),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img_box"},[_c('img',{attrs:{"src":require("../assets/images/404.png")}})])
}]

export { render, staticRenderFns }